/**
 * 의약품 생성·상세 Select 옵션.
 * 값은 백엔드 `ruda-api` enum / 식약처 CANCEL_NAME과 맞춘다.
 */

export type DrugSelectOption = { value: string; label: string };

/** `DrugAdministrationRouteType` */
export const ADMINISTRATION_ROUTE_TYPE_OPTIONS = [
  { value: '내복', label: '내복' },
  { value: '주사', label: '주사' },
  { value: '외용', label: '외용' },
  { value: '기타', label: '기타' },
  { value: '경구', label: '경구' },
] as const;

/** `DrugReimbursementType` */
export const REIMBURSEMENT_TYPE_OPTIONS = [
  { value: '급여', label: '급여' },
  { value: '급여정지', label: '급여정지' },
  { value: '보훈급여', label: '보훈급여' },
  { value: '비급여', label: '비급여' },
  { value: '삭제', label: '삭제' },
  { value: '산정불가', label: '산정불가' },
  { value: '임의불가', label: '임의불가' },
] as const;

/** `DrugEtcOtcType` */
export const ETC_OTC_TYPE_OPTIONS = [
  { value: '전문', label: '전문' },
  { value: '일반', label: '일반' },
  { value: '건기식', label: '건기식' },
  { value: '의약외품', label: '의약외품' },
] as const;

/** `DrugDataSourceType` */
export const DATA_SOURCE_TYPE_OPTIONS = [
  { value: 'API', label: 'API' },
  { value: 'DUR', label: 'DUR' },
  { value: 'ADMIN', label: 'ADMIN' },
  { value: 'HIRA', label: 'HIRA' },
] as const;

/**
 * 등록 상태. 백엔드 enum은 없고 식약처 `CANCEL_NAME`을 그대로 저장한다.
 * 상세 예시값은 `등록`, 배치 테스트는 `정상`·`취하`를 쓴다.
 */
export const REGISTRATION_STATUS_TYPE_OPTIONS = [
  { value: '등록', label: '등록' },
  { value: '정상', label: '정상' },
  { value: '취소', label: '취소' },
  { value: '취하', label: '취하' },
  { value: '폐업', label: '폐업' },
  { value: '행정(취소)', label: '행정(취소)' },
] as const;

export const BOOLEAN_FLAG_OPTIONS = [
  { value: 'true', label: '예' },
  { value: 'false', label: '아니오' },
] as const;

export const EXPOSE_FLAG_OPTIONS = [
  { value: 'true', label: '노출' },
  { value: 'false', label: '미노출' },
] as const;

/** 서버에만 있는 값이 옵션에 없으면 그대로 보여 준다 */
export const optionsWithCurrent = (
  options: readonly DrugSelectOption[],
  current?: string | null,
): DrugSelectOption[] => {
  const value = current?.trim();
  if (!value || options.some((option) => option.value === value)) {
    return [...options];
  }
  return [...options, { value, label: value }];
};

export const REFERENCE_TAB_KEYS = {
  BASIC: 'basic',
  LICENSE: 'license',
  MAPPING: 'mapping',
} as const;

export type ReferenceTabKey =
  (typeof REFERENCE_TAB_KEYS)[keyof typeof REFERENCE_TAB_KEYS];
